import React, { useState } from "react";


import {
  FaIndustry,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function ManufacturingIndustrialPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Operations & Asset Management",
      points: [
        "Predictive Maintenance Agent",
        "Fault Detection & Alert Agent",
        "Digital Twin Simulation Agent",
        "Component Lifespan Prediction Agent",
        "Energy Consumption Optimization Agent",
      ],
    },

    {
      title: "Quality & Production",
      points: [
        "Real-Time Vision QC Agent",
        "Root Cause Analysis Agent for Defects",
        "Automated Quality Feedback Loop Agent",
        "Process Stability Monitoring Agent",
        "Waste Reduction & Sustainability Agent",
      ],
    },

    {
      title: "Planning & Scheduling",
      points: [
        "Dynamic Production Scheduling Agent",
        "Demand Forecasting Agent",
        "Workforce & Shift Scheduling Agent",
        "Resource Bottleneck Prediction Agent",
        "Downtime Minimization Agent",
      ],
    },

    {
      title: "Supply Chain & Inventory",
      points: [
        "Inventory Level Prediction Agent",
        "Automatic Reordering & Supplier Agent",
        "Supplier Scorecard & Risk Assessment Agent",
        "Logistics Optimization Agent",
        "Cold Chain Monitoring Agent",
      ],
    },

    {
      title: "Customer & Product Lifecycle",
      points: [
        "Post-Sales Service Prediction Agent",
        "Predictive Product Servicing Agent",
        "Warranty Claim Support Agent",
        "Product Lifecycle Value Analysis Agent",
        "End-of-Life Recycling Planner Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .manufacturing-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .manufacturing-hero {
          background: #173b8f;
          width: 100%;
        }

        .manufacturing-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .manufacturing-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .manufacturing-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .manufacturing-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .manufacturing-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .manufacturing-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .manufacturing-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .manufacturing-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .manufacturing-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .manufacturing-card-header.active {
          background: #173b8f;
        }

        .manufacturing-card-header.inactive {
          background: #ffffff;
        }

        .manufacturing-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .manufacturing-card-title.active {
          color: #ffffff;
        }

        .manufacturing-card-title.inactive {
          color: #173b8f;
        }

        .manufacturing-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .manufacturing-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .manufacturing-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .manufacturing-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .manufacturing-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .manufacturing-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .manufacturing-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .manufacturing-hero-inner {
            padding: 32px 0px;
          }

          .manufacturing-title {
            font-size: 30px;
          }

          .manufacturing-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .manufacturing-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .manufacturing-icon-box {
            width: 40px;
            height: 40px;
          }

          .manufacturing-icon-box svg {
            font-size: 18px;
          }

          .manufacturing-title {
            font-size: 26px;
          }

          .manufacturing-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .manufacturing-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .manufacturing-card-header {
            padding: 12px 16px;
          }

          .manufacturing-card-title {
            font-size: 15px;
          }

          .manufacturing-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .manufacturing-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .manufacturing-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .manufacturing-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .manufacturing-icon-box svg {
            font-size: 16px;
          }

          .manufacturing-title {
            font-size: 21px;
          }

          .manufacturing-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .manufacturing-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .manufacturing-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .manufacturing-card-header {
            padding: 10px 14px;
          }

          .manufacturing-card-title {
            font-size: 14px;
          }

          .manufacturing-card-content {
            padding: 14px 14px;
          }

          .manufacturing-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .manufacturing-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .manufacturing-point-check svg {
            font-size: 9px;
          }

          .manufacturing-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .manufacturing-title {
            font-size: 18px;
          }

          .manufacturing-card-title {
            font-size: 13px;
          }

          .manufacturing-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="manufacturing-wrapper">
        {/* HERO SECTION */}
        <div className="manufacturing-hero">
          <div className="manufacturing-hero-inner">
            <div className="manufacturing-hero-top">
              <div className="manufacturing-icon-box">
                <FaIndustry />
              </div>

              <h1 className="manufacturing-title">
                Manufacturing & Industrial
              </h1>
            </div>

            <p className="manufacturing-description">
              This sector is all about the production of goods using
              machines, tools, and labor. AI agents power smart
              factories with predictive maintenance, robotics
              coordination, supply chain forecasting, and defect
              detection, increasing speed and reducing waste.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="manufacturing-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="manufacturing-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`manufacturing-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`manufacturing-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="manufacturing-chevron-active" />
                  ) : (
                    <FaChevronDown className="manufacturing-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="manufacturing-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="manufacturing-point-row">
                        <div className="manufacturing-point-check">
                          <FaCheck />
                        </div>

                        <p className="manufacturing-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ManufacturingIndustrialPage;
